import React from 'react'
import * as Article from 'components/ArticleComponents'

export const Section = ({ title, children }) => (
	<>
		{title && <Article.H2>{title}</Article.H2>}
		{children}
	</>
)
